import { ofType } from 'redux-observable';
import { map, switchMap } from 'rxjs/operators';
import { Type } from './redux';

const getQuestionnaireInfo = (action$, state$, { fetch }) =>
  action$.pipe(
    ofType(Type.GET_QUESTIONNAIRE_INFO),
    switchMap(({ questionnaireId, classroomId, scope }) =>
      fetch({
        url:
          '/mm-tiku/web/j/mocQuestionnaireReportBean.getQuestionnaireReportOverview.rpc',
        method: 'POST',
        scope,
        body: {
          questionnaireId,
          classroomId,
        },
      }),
    ),
    map(({ name, submitedCount }) => ({
      type: Type.GET_QUESTIONNAIRE_INFO_SUCCESS,
      name,
      submitedCount,
    })),
  );

// 获取爱多思token
const getEdsToken = (action$, state$, { fetch }) =>
  action$.pipe(
    ofType(Type.GET_EDS_TOKEN),
    switchMap(() =>
      fetch({
        url: '/web/j/toupingBean.genEdsToken.rpc',
        method: 'POST',
      }),
    ),
    map(res => ({
      type: Type.GET_EDS_TOKEN_SUCCESS,
      token: res,
    })),
  );

export default [getQuestionnaireInfo, getEdsToken];
